import EventEmitter from "events";
import { PodcastEvent } from "../constants";

interface PodcastEpisodeProps {
    element: HTMLElement;
}

export class PodcastEpisode extends EventEmitter {
    private element: HTMLElement;
    private _selected: boolean = false;
    private _src: string = "";

    constructor({ element }: PodcastEpisodeProps) {
        super();
        this.element = element;
        this.init();
    }

    init(): void {
        this.element.addEventListener("click", (event: MouseEvent) => {
            event.preventDefault();
            event.stopPropagation();
            this.emit(PodcastEvent.SELECT_EPISODE, this);
        });
    }

    select(): void {
        this._selected = true;

        if (!this._src) {
            this._src = this.audio.dataset.src;
            this.audio.src = this._src;
        }

        this.updateUI();
    }

    deselect(): void {
        this._selected = false;
        this.updateUI();
    }

    updateUI(): void {
        const func = this._selected ? "add" : "remove";
        this.element.classList[func]("selected");
    }

    get audio(): HTMLAudioElement {
        return this.element.querySelector("audio") as HTMLAudioElement;
    }
}